import { sanitizeRichTextHtml } from '@/shared/utils/sanitize-html';

const SUPPORTED_RICH_TEXT_TAG_PATTERN =
	/<\/?(?:p|br|strong|b|em|i|u|a|ul|li)(?:\s[^>]*)?\/?>/i;

function escapeHtml(text: string): string {
	return text
		.replace(/&/g, '&amp;')
		.replace(/</g, '&lt;')
		.replace(/>/g, '&gt;')
		.replace(/"/g, '&quot;')
		.replace(/'/g, '&#39;');
}

export function normalizeCareersDescription(
	description: string | null | undefined
): string {
	if (!description) return '';

	if (SUPPORTED_RICH_TEXT_TAG_PATTERN.test(description)) {
		return sanitizeRichTextHtml(description);
	}

	const plainTextHtml = `<p>${escapeHtml(description).replace(/\r\n?|\n/g, '<br>')}</p>`;
	return sanitizeRichTextHtml(plainTextHtml);
}
